export async function detectBreakpoint(cookie, userAgent) {
  try {
    if (cookie && cookie in this.breakpoints) {
      return cookie;
    }
    const { default: UAParser } = await import(
      /* webpackChunkName: "ua-parser-js" */
      "ua-parser-js"
    );
    const parser = new UAParser(userAgent);
    const { type: deviceType = "" } = parser.getDevice();
    if (deviceType in this.defaultBreakpoints) {
      return this.defaultBreakpoints[deviceType];
    }
    return this.fallbackBreakpoint;
  } catch (error) {
    console.error(error);
    return this.fallbackBreakpoint;
  }
}
export function parseCookie(input) {
  if (!input.length) {
    return {};
  }
  return Object.fromEntries(input.split(/; */).map((cookie) => cookie.split("=", 2)));
}
